

export class Employee_Dashboard_Monthly_Present_Absent implements IEmployee_Dashboard_Monthly_Present_Absent {
    employeeId!: number | undefined;
    absentDay!: number | undefined;
    presentPercentage!: number | undefined;
    absentPercentage!: number | undefined;
    leavePercentage!: number | undefined;
    workingDay!: number | undefined;
    presentDay!: number | undefined;
    leaveDay!: number | undefined;

    constructor(data?: IEmployee_Dashboard_Monthly_Present_Absent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.absentDay = _data["absentDay"];
            this.presentPercentage = _data["presentPercentage"];
            this.absentPercentage = _data["absentPercentage"];
            this.leavePercentage = _data["leavePercentage"];
            this.workingDay = _data["workingDay"];
            this.presentDay = _data["presentDay"];
            this.leaveDay = _data["leaveDay"];
        }
    }

    static fromJS(data: any): Employee_Dashboard_Monthly_Present_Absent {
        data = typeof data === 'object' ? data : {};
        let result = new Employee_Dashboard_Monthly_Present_Absent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["absentDay"] = this.absentDay;
        data["presentPercentage"] = this.presentPercentage;
        data["absentPercentage"] = this.absentPercentage;
        data["leavePercentage"] = this.leavePercentage;
        data["workingDay"] = this.workingDay;
        data["presentDay"] = this.presentDay;
        data["leaveDay"] = this.leaveDay;
        return data; 
    }
}

export interface IEmployee_Dashboard_Monthly_Present_Absent {
    employeeId: number | undefined;
    absentDay: number | undefined;
    presentPercentage: number | undefined;
    absentPercentage: number | undefined;
    leavePercentage: number | undefined;
    workingDay: number | undefined;
    presentDay: number | undefined;
    leaveDay: number | undefined;
}

